import { ContactTypePage } from "@/features/contact-type/pages/ContactType";
import React from "react";

const ContactType = () => {
  return <ContactTypePage />;
};

export default ContactType;
